import { render } from "./page-loader.vue?vue&type=template&id=a80339cc&scoped=true"
const script = {}

import "./page-loader.vue?vue&type=style&index=0&id=a80339cc&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/ciyc-web-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a80339cc"]])

export default __exports__